import React from "react";
import SectionTitle from "./SectionTitle";
import { useTranslation } from "react-i18next";
import "../i18n";
import Icon from "./Icons";

const Contact = () => {
  const { t } = useTranslation();

  return (
    <section id="contact" className="section contact-section">
      <div className="page-container">
        <div className="contact-layout">
          <div>
            <SectionTitle
              align="left"
              eyebrow={t("contact_eyebrow")}
              title={t("contact_title")}
              subtitle={t("contact_text")}
            />
            <p className="contact-note">{t("contact_note")}</p>
          </div>

          <div className="contact-actions">
            <a
              className="contact-primary"
              href={`mailto:${t("contact_email")}`}
            >
              <Icon name="email" />
              <span>{t("contact_email")}</span>
              <Icon name="arrowRight" />
            </a>

            <div className="contact-secondary-actions">
              <a
                href="https://t.me/l3route"
                target="_blank"
                rel="noreferrer"
              >
                <Icon name="telegram" />
                <span>Telegram</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact;
